import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ReplaySubject, Subject, takeUntil, switchMap, from, catchError, EMPTY } from 'rxjs';

@Component({
    selector: 'tt-accountproduct',
    templateUrl: './accountproduct.component.html',
    styleUrls: ['./accountproduct.component.css'],
})
export class AccountproductComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public params?: GetAccountProductParams;

    public params$ = new ReplaySubject<GetAccountProductParams>(1);

    public destroy$ = new Subject<void>();

    public get?: AccountProductGet;

    public grid?: GridOptions;

    constructor(
        private datatask: DataTaskService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.params$
            .pipe(
                takeUntil(this.destroy$),
                switchMap((params) => from(this.getAccountProduct(params)).pipe(catchError((err) => EMPTY))),
            )
            .subscribe({
                next: (get) => {
                    this.get = get;
                    this.navigator?.setHeading?.(this.get.heading ?? '');
                    this.readGrid();
                },
            });
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('accountproduct.grid').setLoadDataFunction({ method: 3717, parameters: () => this.get });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async getAccountProduct(params: GetAccountProductParams): Promise<AccountProductGet> {
        return (await this.datatask.Post(3718, params))[0];
    }

    private async init(params: GetAccountProductParams) {
        this.params = params;
        this.params$.next(this.params);
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.init(this.navigator.params as any);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']?.currentValue) {
            this.init(changes['params'].currentValue);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.params$.complete();
    }
}

interface AccountProductGet {
    heading: string;
}

interface GetAccountProductParams {
    prod_id: string;
}
